import PageHead from '@/components/common/PageHead';
import Container from '@/components/common/Container';
import InnerHero from '@/components/InnerHero/InnerHero';
import Section from '@/components/common/Section';
import Box from '@/components/common/Box/Box';

import Address from '@/components/Pages/Contacts/Address';
import BackgroundHero from '@/components/common/Background/BackgroundHero';

import innerHero from '@/db/contacts/contactsHero.json';
import contactsData from '@/db/contacts/contactsData.json';
import ServicesLayout from '@/components/Pages/Services/ServicesLayout';

import contactsMeta from '@/db/contacts/contactsMeta.json';

const Contacts = () => {
  return (
    <>
      <PageHead {...contactsMeta} />

      <Box className=" relative">
        <Container>
          <Section className="pt-5 pb-5 md:pb-10">
            <InnerHero innerHero={innerHero} />
          </Section>
        </Container>
        <BackgroundHero />
      </Box>

      <Container>
        <Section className="pt-5 pb-5 md:pb-10">
          <Address contactsData={contactsData} />
        </Section>
      </Container>
    </>
  );
};

Contacts.PageLayout = ServicesLayout;

export default Contacts;
